( function () {
	'use strict';

	function jasperAuthService ( apiService, logger ) {
		function setJasperToken () {
			apiService.jasperAuthenticate()
			.success( function ( resource ) {
				localStorage.setItem( 'jaspertoken', resource );
			} )
			.error( function ( error ) {
				logger.notifyEerror( 'Unauthorized. ' + error );
			} );
		}

		var service = {
			'setJasperToken' : setJasperToken
		};

		return service;
	}

	angular
		.module( 'app.core' )
		.factory( 'jasperAuthService', jasperAuthService );
} )();
